import React from "react";
import PropTypes from "prop-types";
import {getTranslation} from "../../helpers/get-translation";
import {connect} from "react-redux";
import {addToast} from "../../ducks/duck-screen";
import {updateUserAvatar, uploadImageToStorage} from "../../ducks/duck-user";

export const AVATAR_INPUT_ID = "change-avatar";
class UploadAvatar extends React.Component {
    interval = null;

    componentDidMount() {
        this.interval = setInterval(()=>{
            if(document.getElementById(AVATAR_INPUT_ID) !== null){
                clearInterval(this.interval);
                document.getElementById(AVATAR_INPUT_ID).addEventListener("change", this.uploadAvatar)
            }
        }, 100)
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        document.getElementById(AVATAR_INPUT_ID).removeEventListener("change", this.uploadAvatar)
    }

    uploadAvatar = (e) => {
        const file = e.target.files[0];

        if (!file || !this.checkIfUploadIsImage(file)) {
            //TODO toast że był problem z uploadem
            this.props.addToast("toast_browse_file_error");
            return
        }

        const { uploadImageToStorage, uid } = this.props;
        const fileExtension = this.getFileExtension(file);
        uploadImageToStorage(uid, file, fileExtension);

        this.changeUserAvatarFromFile(file);
    };

    showFileSelect = () => {
        document.getElementById(AVATAR_INPUT_ID).click();
    };

    changeUserAvatarFromFile = (file) => {
        const reader = new FileReader();
        const { updateUserAvatar } = this.props;
        reader.onload = function(e) {
            updateUserAvatar(e.target.result);
        };

        reader.readAsDataURL(file);
    };

    checkIfUploadIsImage = (file) => {
        return file.type === "image/png" ||
            file.type === "image/jpg" ||
            file.type === "image/jpeg"
    };

    getFileExtension = (file) => {
        if(file.type === "image/png"){
            return "png"
        } else {
            return "jpg"
        }
    };

    render() {
        return (
            <input type="file"
                   name="avatar"
                   style={{ display: "none" }}
                   id={AVATAR_INPUT_ID}
                   accept="image/png, image/jpeg, image/jpg"/>
        )
    }
}

UploadAvatar.propTypes = {
    uid: PropTypes.string.isRequired,

    uploadImageToStorage: PropTypes.func.isRequired,
    updateUserAvatar: PropTypes.func.isRequired,
    addToast: PropTypes.func.isRequired
};

function mapStateToProps(state){
    return {
        uid: state.userReducer.uid,
    }
}

export default connect(
    mapStateToProps,
    {
        addToast,
        uploadImageToStorage,
        updateUserAvatar
    }
)(UploadAvatar);
